import { StarsExtraIcon } from '@braskai/icons';
import { useLocalStorage } from 'react-use';

import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { PromoBanner } from '@/shared/ui/PromoBanner';

const LS_SHOW_TRIAL_SIDEBAR_BANNER = 'showTrialSidebarBanner';

export const TrialSidebarBanner = () => {
  const [show, setShowBanner] = useLocalStorage(LS_SHOW_TRIAL_SIDEBAR_BANNER, true);

  const handleClose = () => {
    setShowBanner(false);
  };

  const isShowBanner = show && !IS_WHITE_LABEL;

  if (!isShowBanner) {
    return null;
  }

  return (
    <PromoBanner
      title="Unlock advanced features and take your video translations to the next level!"
      link={{
        children: 'Upgrade to full version',
        to: `/${PATHS.pricing}`,
      }}
      icon={<StarsExtraIcon />}
      variant="primary"
      onClose={handleClose}
    />
  );
};
